import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import config from '../siteConfig';

const Tag = props => {
  const { tag } = props;

  return (
    <Link to={`${config.routeTags}/${tag}`} className="tags--tag" rel="tag" key={tag}>
      {tag}
    </Link>
  );
};

Tag.propTypes = {
  tag: PropTypes.string.isRequired,
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag.js